import React from "react";
import {
  loadConfigs,
  redirectTo,
  EventBus,
  getCurrentHash,
  formatConfig,
  getCurrentAppNames,
} from "@alife/spa-helper";
import ReactDOM from "react-dom";
import Dialog from "@alife/next/lib/dialog";
import Button from "@alife/next/lib/button";
import Utils from "@alife/im-alitalk-util";
import LandingPage from "./landing-page";
import classNames from "classnames";
import PWAInstall from "./pwa-install";
import utils from "./utils";
import goldlog, { performanceLog } from "./log";
import reportSEM from "@alife/sem-remarketing";

const { createI18N } = window.IcbuIM.lib.I18N;

const I18N = createI18N({
  namespace: "messenger.pwa",
});

import "./index.scss";

/* ========= weblite尺寸设置========== */
// weblite 外容器 770*578
// list: 294  chat: 476
const LIST_HEIGHT_MAP = {
  expand: 578,
  fold: 44,
  "expand-notificaton": 578 + 100, // 100是浮窗高度
  "fold-notification": 44 + 100,
};

const LIST_WIDTH_MAP = {
  expand: 294,
  fold: 210,
  "expand-notificaton": 294,
  "fold-notification": 210,
};

const CHAT_EXPAND_WIDTH = 770;
const CHAT_EXPAND_HEIGHT = 578;

/**
 * 核心逻辑：
 * 1. weblite初始化
 * 2. 挂载微前端子应用: im-weblite-list/im-weblite-chat
 * 3. 通过postMessage中的type类型进行state数据更新（联系人分配&选中、打开询盘表单等）
 */
class Weblite extends React.Component {
  constructor(props) {
    super(props);
    this.listStatus = "fold"; // 会话列表当前状态
    this.chatStatus = "closechat"; // 会话窗口当前状态
    this.assignLoginIdEncrypt = ""; // 联系人重新分配后的加密loginId
    this.state = {
      webliteConfig: {},
    };
  }
  componentDidMount() {
    /* ============ 记录全局打点所需参数：host============ */
    window.host = "weblite";
    // window.saasGray = true;
    performanceLog(`visit&site=weblite`);

    // 记录当前登录态
    this.isLogin = isLogin();

    /* =========== 初始化 ================= */
    this.microAppDidMount(); // 挂载微应用配置
    this.loadInitialMicroApp(["list"]); // 加载首屏所需微应用
    this.notifyIframe(); // 通知iframe设置正确的初始尺寸
    this.heartbeat(); // 登录态监测

    /* ===========全局事件监听============= */
    // 监听关闭chat窗口
    EventBus.on("im-weblite-chat:closeChat", () => {
      this.resizeChat("closechat");
    });

    // 监听最大化chat窗口
    EventBus.on("im-weblite-chat:maximizeChat", () => {
      this.resizeChat("maxchat");
    });

    // 联系人列表展开/收起
    EventBus.on("im-weblite-list:changeListStatus", (data) => {
      this.resizeList(data.status);
    });

    // 发送完消息
    EventBus.on("im-weblite-chat:sendMessage", (data) => {
      const { webliteConfig = {} } = this.state;
      const { activeLoginIdEncrypt = "", sceneType = "" } = webliteConfig;
      let userId = data.userInfo && data.userInfo.toLoginIdEncrypt;

      const hasSceneType =
        userId === activeLoginIdEncrypt || userId === this.assignLoginIdEncrypt;
      Utils.logMsg({
        toId: data.userInfo && data.userInfo.toLoginId,
        productId: data.userInfo && data.userInfo.productId,
        opId: data.opId,
        sceneType: hasSceneType ? sceneType : "",
      });
      if (data.marketData) {
        Utils.logMarket(data.userInfo, data.marketData);
      }

      // SEM流量营销布点
      this.reportSEMLog(hasSceneType);
    });

    EventBus.on("weblite:notLogin", () => {
      window.parent.postMessage(JSON.stringify({ type: "LOGIN" }), "*");
    });

    EventBus.on("im-weblite-list:selectedItem", () => {
      if (this.props.isPWA) {
        this._landing.classList.add("landing-page-miss");
        this._chat.classList.add("icbu-weblite-chat-show");
      }
    });

    // 控制当前iframe尺寸
    EventBus.on("weblite:windowResize", (data) => {
      this.handleWindowResize(data);
    });

    EventBus.on("im-weblite-chat:meetingChange", (data) => {
      // 针对9510(入会后广播所有端已入会), 忽略处理
      if (data.ignore) {
        return;
      }
      // TODO: 这里有bug, 挂断视频的时候导致weblite宽度被拉伸, 但高度没有撑开; 通过强制选中人会导致其他bug
      let width, height, showType;
      showType = data.type;
      if (data.type === "show") {
        width = "100vw";
        height = "100vh";
        this.meetingShow = true;
      } else {
        width = LIST_WIDTH_MAP["fold"];
        height = LIST_HEIGHT_MAP["fold"];
        this.meetingShow = false;
        this._list.setAttribute("style", `width:${LIST_WIDTH_MAP["fold"]}px`);
        EventBus.publish("im-weblite-list:toggleList", { show: false });
      }
      window.parent.postMessage(
        JSON.stringify({ type: "meetingChange", width, height, showType }),
        "*"
      );
    });

    EventBus.on("im-weblite-list:meetingPush", (data) => {
      // 选中某个人
      EventBus.publish("im-weblite-list:selectContact", {
        activeLoginIdEncrypt: data.contactLoginIdEncrypt,
      });
      // 记一次后面清空
      this.listMeetingPush = data;
    });
    // 监听alitalk过来的事件通知
    window.addEventListener(
      "message",
      (event) => {
        // xss防范：不能判断消息来源是否为国际站域名，当前第三方店铺可以设置自定义域名。-- 店铺付费权益
        // /alibaba.com$/.test(event.origin)
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {}

        if (!data) return false;

        const { type } = data;

        /**=======询盘进沟通============= */
        // 1. 关闭询盘或者提交询盘成功事件
        if (type === "weblite:inquiryFormClosed") {
          this.afterInquiryClosed();
          return false;
        }

        // 2. 询盘进沟通，询盘提交成功
        if (type === "nav2InquirySuc") {
          this.afterInquirySent(data);
          return false;
        }
        /**=======询盘进沟通 end============= */

        if (!/^weblite:/g.test(type)) return false;

        let { webliteConfig = {}, shouldLogin = false } = data;

        console.log(
          "===Receive Post Message",
          JSON.parse(JSON.stringify(data))
        );
        const {
          activeLoginIdEncrypt,
          productId,
          lazyInit,
          attrs = {},
        } = webliteConfig;
        const {
          uid = "",
          pid = "",
          scene = {},
          source = "",
          disabled = false,
        } = attrs;
        const { pageId = "", refer = "", fromPage = "" } = scene;

        // ===处理alitalk点击后传递过来的参数，需要兼容旧版传参逻辑 start===
        // 注：alpha组件某些放在data-上的参数是纯小写，如bizid、contactname等
        attrs.source = source || fromPage || "";
        attrs.sceneType = attrs.sceneType || attrs.scenetype || fromPage || "";
        attrs.bizType = attrs.bizType || attrs.biztype || "";
        attrs.bizId = attrs.bizId || attrs.bizid || "";

        webliteConfig.activeLoginIdEncrypt = activeLoginIdEncrypt || uid;
        webliteConfig.productId = productId || pid;
        webliteConfig.lazyInit = lazyInit || disabled;
        webliteConfig.sceneType = attrs.sceneType;
        window.pageId = pageId;
        // ==== end ===

        // Utils打点使用的一些参数
        Utils.pageId = Utils.pageId || pageId;
        Utils.refer = Utils.refer || refer;

        // 处理场景入口参数
        window["chat_entry_scene"] = scene || {};
        utils.goldlog(`weblite_post_message_received&type=${data.type}`);

        // 判断是否需要重新登录
        if (shouldLogin || this.shouldLogin(type)) {
          EventBus.publish("im-weblite:loginSuccess");
        }

        // 唤起和某个人的聊天窗
        if (type === "weblite:selectContact") {
          // 联系人分配
          const timestamp = Date.now();
          this.contactAutoAssign(webliteConfig).then((ret) => {
            if (ret.code * 1 === 200) {
              // 使用新的联系人ID
              this.assignLoginIdEncrypt = ret.data.receiverLoginIdEncrypt;
              this.selectContact({
                encryptId: this.assignLoginIdEncrypt,
                clickTimestamp: timestamp || Date.now(),
                chatLoaded: !!window.__imWebliteChat__loaded__,
              });
            } else {
              // 降级
              this.selectContact({
                clickTimestamp: timestamp || Date.now(),
                chatLoaded: !!window.__imWebliteChat__loaded__,
              });
            }
          });
        }

        // 更新weblite参数
        this.setState({
          webliteConfig: {
            ...webliteConfig,
            pageId: Utils.pageId,
          },
        });
      },
      false
    );
  }

  /**
   * 判断是否需要重新登录
   * @param {*} type
   * @returns
   */
  shouldLogin = (type) => {
    let need = false;
    if (type === "weblite:reload") {
      need = true;
    }
    if (type === "weblite:selectContact") {
      const loginSucceed = isLogin();
      // 调用xman登录窗完成登录
      if (loginSucceed && loginSucceed !== this.isLogin) {
        this.isLogin = loginSucceed;
        need = loginSucceed;
      }
    }
    return need;
  };

  /**
   * 挂载weblite子应用
   * @param {*} data
   */
  microAppDidMount = () => {
    /* =============子应用配置=================== */
    let MODULES = window["SPA_MODULES"];
    let appConfigs = {};

    // 兼容微应用配置老逻辑
    if (window.webliteMicroConfig) {
      MODULES = window.SPA_MODULES = {
        list: "list",
        chat: "chat",
      };
      appConfigs = formatConfig(window.webliteMicroConfig, [
        MODULES.list,
        MODULES.chat,
      ]);
    } else {
      appConfigs = window["SPA_MODULES_CONFIG"];
    }

    // 加载子应用
    loadConfigs(
      appConfigs.map((node) => {
        if (node.appName === MODULES.chat) {
          node.customProps = {
            EventBus,
            redirectTo,
            getCurrentHash,
            SPA_MODULES: MODULES,
            getCurrentAppNames,
            boxWidth: 476,
            boxHeight: 578,
            toolbar: ["emotion", "image", "attachment"],
            host: "weblite",
            selector: "#icbu-weblite-chat",
          };
          if (this.props.isPWA) {
            node.customProps.boxWidth = "100%";
            node.customProps.boxHeight = "100%";
            node.customProps.host = "pwa";
          }
        } else if (node.appName === MODULES.list) {
          node.customProps = {
            EventBus,
            redirectTo,
            getCurrentHash,
            getCurrentAppNames,
            host: "weblite",
            selector: "#icbu-weblite-list",
          };
        }
        // node.customProps.pageId = pageId;
        return node;
      })
    );
  };

  /**
   * 加载初始化需要的子应用
   * @param {*} list  ['chat','list']
   */
  loadInitialMicroApp = (list = []) => {
    let MODULES = window["SPA_MODULES"];
    const { webliteConfig = {} } = this.state;
    const { params = {} } = webliteConfig;

    // 判断是否为PWA应用
    params.isPWA = isPWA();

    list.forEach((v) => {
      const appName = MODULES[v];
      // 加载目标应用js文件
      redirectTo({
        appName: appName,
        hash: appName,
        params: {
          ...params,
          ...params.attrs, // params.attrs中可能有额外的字段需要传递给子应用, 这里将这些额外字段提升一层，与执行EventBus.publish时传递的参数格式相对应
        },
      });
    });
  };

  /**
   * 联系人重新分配逻辑
   * @param {*} webliteConfig
   */
  contactAutoAssign = (webliteConfig = {}) => {
    const { attrs = {}, activeLoginIdEncrypt = "" } = webliteConfig;
    const { bizType, bizId } = attrs;
    return new Promise((resolve, reject) => {
      // 参数必传，否则调用会报错
      if (activeLoginIdEncrypt && bizType && bizId) {
        const params = JSON.stringify({
          contactLoginIdEncrypt: activeLoginIdEncrypt,
          bizType: bizType,
          bizId: bizId,
        });
        fetch("https://onetalk.alibaba.com/csrf/getToken.htm", {
          cache: "no-cache",
          method: "POST",
          mode: "cors",
          headers: {
            "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          credentials: "include",
        })
          .then((res) => {
            return res.json();
          })
          .then((ret) => {
            return this.fetchAssignedContact(
              params,
              ret.token,
              resolve,
              reject
            );
          })
          .catch(() => {
            this.fetchAssignedContact(params, "", resolve, reject);
          });
      } else {
        // 参数缺失，则不调用分配接口
        resolve({});
      }
    });
  };

  /**
   * 调用接口，查询重新分配的联系人ID
   * @param {*} params
   * @param {*} token
   * @param {*} resolve
   * @param {*} reject
   */
  fetchAssignedContact = (params, token, resolve, reject) => {
    const url = "https://onetalk.alibaba.com/message/distributeChat.htm";
    return fetch(url, {
      cache: "no-cache",
      method: "POST",
      mode: "cors",
      headers: {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      credentials: "include",
      body: utils.serialize({
        params,
        _csrf: token,
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        performanceLog(
          "weblite_distribute_failed&" + utils.JSONParam(JSON.parse(params))
        );
        reject(err);
      });
  };

  /**
   * 改变chat窗口尺寸
   * @param {*} status closechat/maxchat
   */
  resizeChat = (status = "closechat") => {
    if (status === "maxchat") {
      if (this.listMeetingPush) {
        // 唤起chat的音视频
        const info = Object.assign({}, this.listMeetingPush);
        setTimeout(() => {
          EventBus.publish("im-weblite-chat:meetingPush", info);
        }, 1000);
        this.listMeetingPush = null;
      }
    }

    if (this.chatStatus !== status) {
      // 通知alitalk改变iframe尺寸
      this.chatStatus = status;
      this.notifyIframe();
    }
    //yuri，问卷，商详发消息流失 TODO: 判断localstorage 先不做
    if (status === "closechat") {
      utils.goldlog("weblite_closeChat");
    }
  };

  /**
   * 改变list窗口尺寸
   * @param {*} status fold/expand
   */
  resizeList = (status = "fold") => {
    const { webliteConfig = {} } = this.state;

    if (this.listStatus !== status) {
      // list收起的时候将chat关闭
      let listWidth;
      if (status === "fold") {
        this.resizeChat("closechat");
        listWidth = LIST_WIDTH_MAP[isPWA() ? "expand" : "fold"];
        this._list.classList.remove("icbu-weblite-list-expand");
      } else {
        listWidth = LIST_WIDTH_MAP["expand"];
        this._list.classList.add("icbu-weblite-list-expand");
      }
      this._list.setAttribute("style", `width:${listWidth}px`);
      // 通知alitalk改变iframe尺寸
      this.listStatus = status;
      this.notifyIframe();
    }

    // 埋点
    const log_key = status === "expand" ? "openatm" : "webclick";
    const log_params = {
      fromuid: "enaliint" + Utils.getLoginId(),
      from: 1,
      time: +new Date(),
      version: "new",
      id: webliteConfig.productId,
      refer: Utils.refer ? Utils.refer.replace(/&/gi, "$") : "",
    };
    Utils.dmtrackLog(log_key, log_params);
  };

  // weblite窗体尺寸调整
  handleWindowResize = (data) => {
    let width, height, showType;
    showType = data.type;
    if (data.type === "show") {
      width = "100vw";
      height = "100vh";
    } else {
      width = CHAT_EXPAND_WIDTH;
      height = CHAT_EXPAND_HEIGHT;
    }
    window.parent.postMessage(
      JSON.stringify({ type: "meetingChange", width, height, showType }),
      "*"
    );
  };

  // 保持登录态session
  heartbeat() {
    let relayScriptEl = null,
      minutes = 5;
    const relay = () => {
      relayScriptEl.src = `//login.alibaba.com/xlogin/relay.htm?_=${Date.now()}`;
    };
    relayScriptEl = document.createElement("script");
    relayScriptEl.type = "text/javascript";
    document.head.appendChild(relayScriptEl);
    setInterval(relay, minutes * 60 * 1000);
  }

  /**
   * 打开某个联系人的会话
   * @param {*} activeLoginIdEncrypt
   */
  selectContact({ encryptId, clickTimestamp, chatLoaded }) {
    const { webliteConfig = {} } = this.state;
    const {
      attrs = {},
      productId = "",
      activeLoginIdEncrypt = "",
    } = webliteConfig;
    let { sceneData, action, source, bizId = "", ...others } = attrs;

    utils.goldlog(
      `weblite_selectContact&action=${action || ""}&source=${source || ""}`
    );

    // 通知list子应用，打开对应的联系人
    EventBus.publish("im-weblite-list:selectContact", {
      productId,
      activeLoginIdEncrypt: encryptId || activeLoginIdEncrypt,
      sceneData, // 目前只有信保订单完成页面使用, 后续不建议用这个
      action, // 唤起动作
      source, // 页面来源
      sourceId: bizId, // 页面来源对应的场景id, 比如产品id, 短视频id
      clickTimestamp,
      chatLoaded,
      others,
    });
  }

  /**======= 询盘表单逻辑 ================== */

  // 处理询盘表单关闭后的逻辑
  // 这个地方的goldlog打点不要放到closeInquiry里，兼容alitalk过来的事件通知
  afterInquiryClosed = () => {
    EventBus.publish("im-weblite-chat:closeInquiry");

    //yuri问卷:商详询盘流失，黄金令箭打点后会触发问卷提示
    const _time = localStorage.getItem("InquirySuccessTime");
    const _expire = 24 * 60 * 60 * 1000; //一天
    if (!_time || Date.now() - _time >= _expire) {
      utils.goldlog("productDetail_showInquiryFailed");
    }
  };

  // 处理询盘表单提交后的逻辑
  afterInquirySent = (data) => {
    //yuri问卷:商详询盘成功，黄金令箭打点后会触发问卷提示
    const _time = localStorage.getItem("InquirySuccessTime");
    const _expire = 24 * 60 * 60 * 1000; //一天
    if (!_time || Date.now() - _time >= _expire) {
      utils.goldlog("productDetail_showInquirySucceed");
      localStorage.setItem("InquirySuccessTime", Date.now());
    }
  };

  /**
   * 通知alitalk改变iframe尺寸,postMessage:CHANGE_SIZE
   */
  notifyIframe() {
    // 音视频展示的时候优先级最高, 窗口最大化
    if (this.meetingShow) {
      return false;
    }
    let width, height;
    if (this.chatStatus === "maxchat") {
      width = CHAT_EXPAND_WIDTH;
      height = CHAT_EXPAND_HEIGHT;
    } else if (this.chatStatus === "closechat") {
      width = LIST_WIDTH_MAP[this.listStatus];
      height = LIST_HEIGHT_MAP[this.listStatus];
    }
    // 不能使用top, 因为OP自身可能是通过iframe被嵌入的, 比如cnfm场景, 因此使用parent
    window.parent.postMessage(
      JSON.stringify({ type: "CHANGE_SIZE", width: width, height: height }),
      "*"
    );
  }

  /**
   * 流量营销打点
   * {productId, pageLanguage, pageType, siteName, categoryId}
   */
  reportSEMLog = (hasSceneType) => {
    const { webliteConfig = {} } = this.state;
    reportSEM({
      productId: hasSceneType ? webliteConfig.productId : "",
      pageType: "atm",
      siteName: "atm",
    });
  };

  render() {
    const landingPageCls = classNames({
      "landing-page": true,
    });
    const chatCls = classNames({
      "icbu-weblite-chat": true,
    });
    // list的宽度必须动态设置, 否则跟随iframe宽度100%会有问题
    return (
      <div className="icbu-weblite" id="icbu-weblite">
        <div
          id="icbu-weblite-list"
          className="icbu-weblite-list"
          style={{
            width: this.props.isPWA
              ? `${LIST_WIDTH_MAP["expand"]}px`
              : `${LIST_WIDTH_MAP["fold"]}px`,
          }}
          ref={(list) => (this._list = list)}
        ></div>
        <div
          id="icbu-weblite-chat"
          className={chatCls}
          ref={(chat) => (this._chat = chat)}
        ></div>
        {this.props.isPWA && (
          <div
            className={landingPageCls}
            ref={(landing) => (this._landing = landing)}
          >
            <LandingPage updateChrome={this.props.updateChrome} />
          </div>
        )}
        {this.props.isPWA &&
          !this.props.isMigrate &&
          !this.props.updateChrome && <PWAInstall version="supplier" />}
      </div>
    );
  }
}

// 注意: 即使调用多次, 后续也只是更新组件, 不会重新创建
ReactDOM.render(
  <Weblite
    isPWA={isPWA()}
    updateChrome={updateChrome()}
    isMigrate={isMigrate()}
  />,
  document.getElementById("app")
);

/* ======== 一些全局通用方法 ======== */

/**
 * 判断当前是否已经登录
 */
function isLogin() {
  var loginCookie = Utils.getCookie("xman_us_t") || "";
  return /sign=y/g.test(loginCookie);
}

/**
 * 是否为PWA
 */
function isPWA() {
  // weblitePWA是给mac版使用; webATM只使用了weblite的壳, 不会提示安装PWA, 用于升级老webatm
  return (
    location.href.indexOf("weblitePWA") != -1 ||
    location.href.indexOf("webATM") != -1
  );
}

function isMigrate() {
  return location.href.indexOf("enemberId") !== -1;
}

// 判断是否需要更新chrome
function needUpdateChrome() {
  const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  const version = raw ? parseInt(raw[2], 10) : false;
  return version && version < 76;
}

/**
 * 针对PWA的一些额外处理逻辑
 */
if (isPWA()) {
  window.addEventListener("load", () => {
    initPWA();
  });
}

/**
 * 初始化PWA
 */
function initPWA() {
  const webliteData = {
    webliteConfig: {
      activeLoginIdEncrypt: "",
      productId: "",
      sceneType: "pwa",
    },
    type: "weblite:init",
    refer: location.href,
    pageId: window.dmtrack_pageid || "",
  };
  if (isMigrate()) {
    const queryDict = {},
      config = {};
    location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        queryDict[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]);
      });
    config.activeLoginIdEncrypt = queryDict["enemberId"];
    config.productId = queryDict["pid"];
    config.sceneType = queryDict["sceneType"];
    config.lazyInit = true;
    webliteData.webliteConfig = config;
    webliteData.type = "weblite:selectContact";
  }
  // 只有weblitePWA需要提示
  if (updateChrome()) {
    const dialog = Dialog.alert({
      needWrapper: false,
      content: I18N.get("detectChrome"),
      title: I18N.get("detectChromeTitle"),
      footer: (
        <Button type="primary" onClick={() => dialog.hide()}>
          OK
        </Button>
      ),
    });
  }
  window.postMessage(
    JSON.stringify(webliteData),
    `${location.protocol}//${location.host}`
  );
}

function updateChrome() {
  return location.href.indexOf("weblitePWA") != -1 && needUpdateChrome();
}

export default Weblite;
